import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $isRangeSelection, COMMAND_PRIORITY_HIGH } from "lexical";
import { useEffect } from "react";
import { $createStylableButtonNode } from "../nodes/stylable-button-mui";
import { INSERT_STYLABLE_BUTTON_COMMAND } from "../types/commands";
import { $insertNode } from "../utils/insert-node";
import { $selectionOrStart } from "../utils/selection-or-start";

import type { StylableButtonCommand } from "../types/commands";

export const StylableButtonPlugin = (): null => {
  const [editor] = useLexicalComposerContext();

  useEffect(
    () =>
      editor.registerCommand(
        INSERT_STYLABLE_BUTTON_COMMAND,
        (data: StylableButtonCommand) => {
          const selection = $selectionOrStart();

          if (!$isRangeSelection(selection)) {
            return false;
          }
          const node = $createStylableButtonNode(
            editor._headless,
            data.text,
            data.url,
            data.buttonType,
            data.fullWidth,
            data.format,
          );
          $insertNode(node);

          return true;
        },
        COMMAND_PRIORITY_HIGH,
      ),
    [editor],
  );

  return null;
};
